<div class="mm-skill-profile-popup-diagram" role="img">
    <canvas #barCanvas ></canvas>
</div>
